import { DataPlatformApi } from '@kcftech/data-platform-sdk';
import { dataPlatformClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

const indicatorFiltersQueryKey = ['data-platform-indicator-filters'] as const;

export function ensureIndicatorFilters() {
    return queryClient.ensureQueryData<DataPlatformApi.FilterResponse[]>({
        queryKey: indicatorFiltersQueryKey,
        queryFn: async () => {
            const response =
                await dataPlatformClient.indicatorFilters.getIndicatorFilters({
                    includeUserFilters: false,
                    includeGlobalFilters: true,
                    limit: 100,
                });
            return response.data;
        },
    });
}

export function ensureIndicatorFiltersByIds(ids: string[]) {
    return queryClient.ensureQueryData<DataPlatformApi.FilterResponse[]>({
        queryKey: [indicatorFiltersQueryKey, ids],
        queryFn: async () => {
            const customFilters =
                await dataPlatformClient.indicatorFilters.getIndicatorFilters({
                    filterId: ids.join(','),
                });

            return customFilters.data;
        },
    });
}
